import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import GeneralMobile from './GeneralMobile';
import GeneralDesktop from './GeneralDesktop';

function General({ app, config, filter}) {
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    return isMobile ? <GeneralMobile app={app} config={config} filter={filter} />
        : <GeneralDesktop app={app} config={config} filter={filter} />;
}

General.defaultProps = {
    app: null,
    config: {},
    filter: ""
};

General.propTypes = {
    app: PropTypes.object,
    config: PropTypes.object,
    filter: PropTypes.string
};

export default General;
